export namespace DomUtils {
  /** Only works for flex-direction: row */
  export function isElementFlexWrapped(element: HTMLElement): boolean {
    const parent = element.parentElement;
    if (!parent) return false;

    const parentStyle = window.getComputedStyle(parent);
    if (parentStyle.display !== 'flex') return false;

    if (element === parent.firstElementChild) return false;

    const previousSibling = element.previousElementSibling as HTMLElement;
    if (!previousSibling) return false;

    return element.getBoundingClientRect().top > previousSibling.getBoundingClientRect().top;
  }

  export function getModalHeight() {
    return window.innerHeight < 700 ? '500px' : '620px';
  }
}
